import { keyframes, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors } from '#/theme/theme';

const aSlideRTLBackground = keyframes`
  from {
    clip-path: inset(0 0 0 100%);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
`;

export const EstimatedRangeButton = styled(ButtonOrLink)`
  background-color: ${colors.selectionGrey};
  border-radius: 8px;
  letter-spacing: 0.5px;
  padding: 8px 16px;
  font-size: 16px;
  border: none;
  color: ${colors.mediumContentGrey};
  position: relative;
  overflow: hidden;
  transition: clip-path;
  line-height: 1;
  height: 39px;

  &::after {
    align-items: center;
    background-color: ${colors.brandBlue};
    clip-path: inset(0 0 0 100%);
    color: white;
    display: flex;
    justify-content: center;
    content: 'Estimated Range';
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
  }

  &[data-active]::after {
    animation: ${aSlideRTLBackground} 1s forwards;
  }

  &:hover {
    color: ${colors.brandBlue};
  }

  &:disabled {
    opacity: 1;

    &:hover {
      color: initial;
    }
  }
`;
